import { Component, OnInit, HostListener } from '@angular/core';
import { AppStateService } from 'src/app/Services/AppState/app-state.service';
import { ActivatedRoute, RouterModule } from "@angular/router";
import Rutas from 'src/app/Models/Base/rutas';
import { UntypedFormGroup, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { deleteAllCookies, getLocalStorage } from 'npx-arc-ui/utils';
import Storage from 'src/app/Models/Base/storage';
import { LoginSoporteComponent } from '../login-soporte/login-soporte.component';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [
    CommonModule
    , MatButtonModule
    , MatInputModule
    , MatFormFieldModule
    , MatIconModule
    , RouterModule
    , FormsModule
    , ReactiveFormsModule
  ]
})
export class LoginComponent implements OnInit {
  form: UntypedFormGroup = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    password: new UntypedFormControl('', [Validators.required])
  })
  expectedSequence = ['shift', 'alt', 'l', 'l', 'l'];
  private modalAbierto = false;
  public hide: boolean = true;
  public rememberMe: boolean = false;
  public registerERP = Rutas.ERP_REGISTER;
  public forgotPassword = Rutas.FORGOT_PASSWORD;
  public isLoading: boolean = false;
  keySequence: string[] = [];
  constructor(
    private route: ActivatedRoute
    , public appStateService: AppStateService) { }

  ngOnInit(): void {
    deleteAllCookies();
    this.appStateService.returnProduct = this.route.snapshot.paramMap.get("ReturnProduct") || "";
    if (this.appStateService.IsAuthGuard()) {
      const token = getLocalStorage<string>(Storage.TOKEN)!.data
      if (!!token.length && this.appStateService.LoginResult) {
        this.appStateService.router.navigateByUrl(Rutas.DOUBLE_FACTOR);
      } else if (!!token.length) {
        this.appStateService.router.navigateByUrl(Rutas.DASHBOARD);
      }
    }
    this.appStateService.IsSupport= false;
  }

  public onSubmit() {
    const { value } = this.form;

    this.appStateService.onLogin(value);
  }

  public LoginSoporte() {
    this.appStateService.dialog.open(LoginSoporteComponent, {
      maxWidth: '95%',
      maxHeight: '95%',
      width: '491px',
    });
  }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const key = event.key?.toLowerCase();

    if (key === this.expectedSequence[this.keySequence.length]) {
      this.keySequence.push(key);
    } else {
      this.keySequence = key === 'shift' ? ['shift'] : []; 
    }

    if (this.keySequence.length === this.expectedSequence.length && !this.modalAbierto) {
      this.modalAbierto = true;
      this.abrirModal();
    }
  }

  @HostListener('window:keyup', ['$event'])
  onKeyUp(event: KeyboardEvent) {
    if (event.key?.toLowerCase() !== 'l') {
      this.keySequence = [];
    }
  }

  abrirModal() {
    const dialogRef = this.appStateService.dialog.open(LoginSoporteComponent, {
      maxWidth: '95%',
      maxHeight: '95%',
      width: '491px',
    });

    dialogRef.afterClosed().subscribe(() => {
      this.modalAbierto = false;
      this.keySequence = [];
    });
  }
}
